import React from 'react'
import styles from './S2DMobileView.scss'
import {CTA} from 'common/styleguide/CTA'
import {base} from 'lib/styleguide/base.scss'
import cx from 'classnames'

export class S2DMobileView extends React.PureComponent {
  render () {
    const {route, routeId, platform} = this.props

    const appLink = platform === 'iphone'
      ? 'itms-apps://appstore.com/ridewithgpsbikecomputer'
      : 'http://play.google.com/store/apps/details?id=com.ridewithgps.mobile'

    const routeLink = `rwgps://app/routes/${routeId}`
    return (
      <div className={cx(styles.S2DMobileView, base)}>
        <div>
          <img height='150' width='150' className={styles.routePreview} src={`/routes/light/${routeId}.png`} />
        </div>
        <h2>Download the free Ride with GPS app to view "{route && route.name}".</h2>
        <CTA href={appLink}>Download on the {platform === 'iphone' ? 'App' : 'Play'} Store</CTA>
        <a href={routeLink} className={styles.hasApp}>Already have the mobile app?</a>
      </div>
    )
  }
}
